exports.ALL = [
	{
	    "Name": "Carpenter",
	    "Daily Wage": "",
	    "Monthly Wage": "$100.00",
	    "Monthly Live-In Wage": "$75.00",
	    "Space": "10'+20'",
	    "Share": "",
	    "Special": "",
    	"Wealth": "3",
    	"Gear": "craft|misc",
	},
	{
	    "Name": "Tailor",
	    "Daily Wage": "",
	    "Monthly Wage": "$100.00",
	    "Monthly Live-In Wage": "$75.00",
	    "Space": "10'+20'",
	    "Share": "",
	    "Special": "",
    	"Wealth": "3",
    	"Gear": "craft|misc",
	},
	{
	    "Name": "Stonemason",
	    "Daily Wage": "",
	    "Monthly Wage": "$100.00",
	    "Monthly Live-In Wage": "$75.00",
	    "Space": "10'+20'",
	    "Share": "",
	    "Special": "",
    	"Wealth": "3",
    	"Gear": "craft|misc",
	},
	{
	    "Name": "Caretaker",
	    "Daily Wage": "",
	    "Monthly Wage": "$100.00",
	    "Monthly Live-In Wage": "$75.00",
	    "Space": "10'+20'",
	    "Share": "",
	    "Special": "",
    	"Wealth": "3",
    	"Gear": "craft|misc",
	},
];


// WEBPACK FOOTER //
// ./src/data/craftsmen.js